<div class="row">
    <!-- <div class="col icon">
        <img src="assets/images/icons/icon-client.svg" alt="">
    </div> -->
    <div class="col">
        <div class="header">
            <ng-container *ngIf="!couldntAttemptMatch && (multiplePotentialClients && multiplePotentialClients > 1)">
                <div class="heading">
                    <img src="../../../../assets/images/icons/icon-client.svg" class="icon">
                    <div class="text">{{ multiplePotentialClients }} matching client records found</div>
                </div>
            </ng-container>
            <ng-container *ngIf="!couldntAttemptMatch && (!multiplePotentialClients || multiplePotentialClients <= 1)">
              <ng-container *ngIf="user$ | async">
                  <client-not-recognised [user]="user$ | async"></client-not-recognised>
              </ng-container>
              <ng-container *ngIf="!(user$ | async)">
                <div class="heading">
                    <img src="../../../../assets/images/icons/icon-client.svg" class="icon">
                    <div class="text">Select Client</div>
                </div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="couldntAttemptMatch">
              <div class="heading">
                <img src="../../../../assets/images/icons/icon-client.svg" class="icon">
                <div class="text">Unmatched</div>
                <div class="error">
                  We had trouble connecting to your PMS when this conversation came in.
                  <ng-container *ngIf="!reloadingClient">
                    <span class="reload-client" (click)="reloadClient()">Try again now</span>
                  </ng-container>
                  <ng-container *ngIf="reloadingClient">
                    <p-progressSpinner [style]="{width: '16px', height: '16px'}" styleClass="pink-spinner" strokeWidth="6"></p-progressSpinner>
                  </ng-container>
                </div>
              </div>
            </ng-container>
        </div>
        <client-selector [disabled]="disabled" (clientSelected)="updateClient($event)" [searchString]="multiplePotentialClients > 1 ? phoneStr : ''" #clientSelector></client-selector>
    </div>
</div>
